import { midiFrequency, type AY38910, type ToneEvent } from './ay38910';
import type { Note, Song } from './music';
export class Sequencer {
  private song:Song|null=null;
  private epoch=0;private nextIndex=0;private cycle=0;
  private notes:Note[]=[];
  get playing():boolean{return this.song!==null;}
  start(song:Song,now:number):void{
    if(this.song===song)return;
    this.song=song;this.epoch=now+0.025;this.nextIndex=0;this.cycle=0;this.notes=[...song.notes].sort((a,b)=>a.beats-b.beats);
  }
  stop():void {this.song=null;}
  update(now:number,psg:AY38910):void{
    const song=this.song;if(!song)return;
    const notes=this.notes;
    const secondsPerBeat=60/song.bpm;
    const events:ToneEvent[]=[];
    for(let guard=0;guard<128;guard++){
      const note=notes[this.nextIndex];if(!note)break;
      const at=this.epoch+(this.cycle*song.length+note.beats)*secondsPerBeat;
      if(at>now+0.15)break;
      if(note.pitch!==null && at>=now-0.05)events.push({channel:note.channel,at:Math.max(at,now),duration:secondsPerBeat*(note.channel===1?0.7:0.38),frequency:midiFrequency(note.pitch),volume:note.volume,priority:0,category:'music',envelope:'decay'});
      this.nextIndex++;
      if(this.nextIndex>=notes.length){if(song.loop){this.nextIndex=0;this.cycle++;}else {this.song=null;break;}}
    }
    if(events.length)psg.schedule(events);
  }
}
